import { createChartServices, IChartServices } from './Main/chart_services';
import { createCommonServices, ICommonServices } from './Main/common_services';
import { createHomeServices, IHomeServices } from './Main/home_services';
import { createUserServices, IUserServices } from './User/user_services';
import { createLanguageServices, ILanguageServices } from './Language/language_services';
import { createZNSServices, IZNSServices } from './ZNS/zns_services';
import { createProjectManagementServices, IProjectManagementServices } from './Main/projectManagement_services';
import { createReportWAndCServices, IReportWAndCServices } from './Main/reportWAndC_service';
import { createReportSavedServices, IReportSavedServices } from './SaveRepoprtTemplete/reportSaved_servieces';
import { ICustomerSegmentServices, createCustomerSegmentServices } from './Main/customerSegment_services';
import { IEventCampaignServices, createEventCampaignServices } from './Main/eventCampaign_services';
import { createMarketingCampaignServices, IMarketingCampaignServices } from './Main/marketingCampaign_services';
import { createContactSegmentServices, IContactSegmentServices } from './Main/contactSegment_services';
import { createCriterialServices, ICriterialServices } from './Main/criterial_services';
import { createCampaignServices, ICampaignServices } from './Main/campaign_services';
import { createCustomerUnidentifiedServices, ICustomerUnidentifiedServices } from './Main/customerUnidentified_services';
import { createSurveyServices, ISurveyServices } from './Survey/survey_services';
import { createReportVisitCustomerSRServices, IReportVisitCustomerSRServices } from './Main/reportVisitCustomerSR';
import { createDocumentArchiveServices, IDocumentArchiveServices } from './Main/documentArchive';
import { createWarrantyRemindServices, IRemindServices } from './Masterdata/warrantyRemind_services';
import { createExchangeRewardsServices, IExchangeRewardsServices } from './Main/exchangeRewards_services';
import { createUnfollowRemindServices, IUnfollowRemindServices } from './Masterdata/unfollowRemind_services';
import { createCustomerGeneralReportServices, ICustomerGeneralReportServices } from './Main/customerGeneralReport_services';


export interface IServices {
  // User services
  userServices: IUserServices;
  // Common services
  commonServices: ICommonServices;
  // Tiêu chí
  criterialServices: ICriterialServices;

  // Chart services
  chartServices: IChartServices;
  // Home services
  homeServices: IHomeServices;
  // Quản lý dự án // project management services
  projectManagementServices: IProjectManagementServices;
  // Báo cáo bảo hành - khiếu nại
  reportWCServices: IReportWAndCServices;
  // Customer segment services
  customerSegmentServices: ICustomerSegmentServices;
  // Contact segment services
  contactSegmentServices: IContactSegmentServices;
  // khách hàng chưa định danh service
  customerUnidentifiedServices: ICustomerUnidentifiedServices;
  // Chiến dịch event
  eventCampaignService: IEventCampaignServices;
  // Chiến dịch marketing
  marketingCampaignService: IMarketingCampaignServices;
  // Campaign
  campaignService: ICampaignServices;
  // BÁO CÁO THĂM HỎI KHÁCH HÀNG
  reportVisitCustomerSRServices: IReportVisitCustomerSRServices;

  // KHO TÀI LIỆU
  documentArchiveServices: IDocumentArchiveServices;
  // TÍCH ĐIỂM ĐỔI QUÀ
  exchangeRewardsServices: IExchangeRewardsServices;



  // Đổi ngôn ngữ
  languageServices: ILanguageServices;
  // ZNS Services
  znsServices: IZNSServices;
  // Lưu mẫu báo cáo
  reportSavedServices: IReportSavedServices;
  // Survey (Mẫu khảo sát, đánh giá)
  surveyServices: ISurveyServices;

  // MASTERDATA
  // warranty remind
  warrantyRemindServices: IRemindServices;
  unfollowRemindServices: IUnfollowRemindServices;

  // báo cáo tổng hợp khách hàng
  customerGeneralReportServices: ICustomerGeneralReportServices;


}

export function createServices(): IServices {
  return {
    // User services
    userServices: createUserServices(),
    // Common services
    commonServices: createCommonServices(),
    // Tiêu chí
    criterialServices: createCriterialServices(),

    // Chart services
    chartServices: createChartServices(),
    // Home services
    homeServices: createHomeServices(),
    // Quản lý dự án // project management services
    projectManagementServices: createProjectManagementServices(),
    // Báo cáo bảo hành - khiếu nại
    reportWCServices: createReportWAndCServices(),
    // Customer segment services
    customerSegmentServices: createCustomerSegmentServices(),
    // Contact segment services
    contactSegmentServices: createContactSegmentServices(),
    // khách hàng chưa định danh service
    customerUnidentifiedServices: createCustomerUnidentifiedServices(),
    // Chiến dịch event
    eventCampaignService: createEventCampaignServices(),
    // Chiến dịch marketing
    marketingCampaignService: createMarketingCampaignServices(),
    // Campaign
    campaignService: createCampaignServices(),

    // Kho tài liệu
    documentArchiveServices: createDocumentArchiveServices(),

    // Đổi ngôn ngữ
    languageServices: createLanguageServices(),

    // ZNS Services
    znsServices: createZNSServices(),
    // Lưu mẫu báo cáo
    reportSavedServices: createReportSavedServices(),
    // Survey (Mẫu khảo sát, đánh giá)
    surveyServices: createSurveyServices(),
    // BÁO CÁO THĂM HỎI KHÁCH HÀNG
    reportVisitCustomerSRServices: createReportVisitCustomerSRServices(),
    // TÍCH ĐIỂM ĐỔI QUÀ
    exchangeRewardsServices: createExchangeRewardsServices(),




    // MASTERDATA
    // warranty remind
    warrantyRemindServices: createWarrantyRemindServices(),
    unfollowRemindServices: createUnfollowRemindServices(),

    customerGeneralReportServices: createCustomerGeneralReportServices()
  };
}
